import CitySEOHead from "@/components/feature/CitySEOHead";
import MTHeroSection from "./components/HeroSection";
import MTCitiesDirectory from "./components/CitiesDirectory";
import MTStateResources from "./components/StateResources";
import MTFAQSection, { faqs } from "./components/FAQSection";
import MTFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const services = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

const mappedFaqs = faqs.map((f) => ({ q: f.question, a: f.answer }));

export default function MontanaPage() {
  return (
    <>
      <CitySEOHead
        city="Montana"
        state="Montana"
        stateAbbr="MT"
        route="/states/montana"
        title="Montana Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Montana — Billings, Missoula, Bozeman, Great Falls, Kalispell, and Helena. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Montana, United States"
        geoPosition="46.8797;-110.3626"
        faqs={mappedFaqs}
        servicesSchema={services}
      />
      <div className="font-sans">
        <MTHeroSection />
        <MTCitiesDirectory />
        <MTStateResources />
        <MTFAQSection />
        <SEOCrossLinks state="MT" />
        <MTFinalCTA />
      </div>
    </>
  );
}